import ViewMerchants from "./component";
import ViewMerchantsContainer from "./container";

export { ViewMerchants, ViewMerchantsContainer };
export default ViewMerchantsContainer;



// WEBPACK FOOTER //
// ./client/modules/Merchant/components/ViewMerchants/index.ts